"use client";

import { TogglePill, type TogglePillProps } from "@repo/ui/components/toggle-pill";
import { useFieldContext } from "@/shared/forms/form-context";

export type TogglePillFieldProps = Omit<TogglePillProps, "value" | "onChange">;

export function TogglePillField(props: TogglePillFieldProps) {
  const field = useFieldContext<boolean>();

  return (
    <TogglePill
      {...props}
      value={field.state.value}
      onChange={(val) => {
        field.handleChange(val);
        field.handleBlur();
      }}
    />
  );
}
